<app-modal-option-panel data-testid="vehicle-property-container">
  <span panel-title class="slider-name">{{ label }}</span>
  @if (stepButtons) {
  <button panel-side-start type="button" class="stepper-btn" data-testid="vehicle-property-decrease-btn" [disabled]="value <= min"
    [attr.aria-label]="'decrease ' + altString" (click)="onStep(-1)">&minus;</button>
  }
  <span panel-side class="slider-value" [class.stepper-value]="stepButtons">{{ displayValue }}</span>
  @if (stepButtons) {
  <button panel-side-end type="button" class="stepper-btn" data-testid="vehicle-property-increase-btn" [disabled]="value >= max"
    [attr.aria-label]="'increase ' + altString" (click)="onStep(1)">+</button>
  }
  <app-ev-slider data-testid="vehicle-property-slider" [min]="min" [max]="max" [digit]="digit"
    [altString]="altString" [value]="value"
    (valueDragEvent)="onValueDrag($event)" (valueChangeEvent)="onValueChange()">
  </app-ev-slider>
</app-modal-option-panel>
